import { render, staticRenderFns } from "./warn.vue?vue&type=template&id=60be14de&scoped=true&"
import script from "./warn.vue?vue&type=script&lang=js&"
export * from "./warn.vue?vue&type=script&lang=js&"
import style0 from "./warn.vue?vue&type=style&index=0&id=60be14de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60be14de",
  null
  
)

export default component.exports